import React from 'react';
import styled from 'styled-components';
import { Box } from '~common/components/box.component';
import { Span } from '~common/components/span.component';

interface Props {
  label: string;
  filename: string;
}

export const MediaFilename: React.FunctionComponent<Props> = ({ label, filename, ...rest }) => {
  return (
    <Container {...rest}>
      <FileName>{filename ?? label}</FileName>
    </Container>
  );
};

const Container = styled(Box)`
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
`;

const FileName = styled(Span)`
  width: 100%;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.8px;
  font-weight: bold;
  text-transform: uppercase;
  border-bottom: 1px solid
    ${(props): string => props.theme.colors.withAlpha(props.theme.colors.white)(0.7)};
  color: ${(props): string => props.theme.colors.gray.v1};
  word-break: break-all;
  padding-bottom: 6px;
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media-file/media-file-name.component.tsx